import React from 'react'
import MediaQuery from 'react-responsive'
import Anchor from 'react-anchor-link-smooth-scroll'
import PropTypes from 'prop-types'

export default function Banner ({ hasCard }) {
  return (
    <div className='container'>
      <div className='row'>
        <div className='col-12 p-0 pt-md-5 d-flex justify-content-center align-items-center'>
          <div className='bg-destaque col-12'>
            <div className='d-flex justify-content-around align-items-center flex-column flex-md-row'>
              <div className='pos-relative'>
                <MediaQuery maxDeviceWidth={768}>
                  <div className='d-flex justify-content-center align-items-center flex-column mt-3 mt-md-0'>
                    <div className='logo-likemais-negativo mt-3' />
                    <h3 className='color-brand-1-like my-2 mt-1'>Mais do que você esperava!</h3>
                  </div>
                </MediaQuery>
                <div className='img-destaque' />
                <div className='img-card pos-absolute' />
              </div>
              <MediaQuery minDeviceWidth={768}>
                <div className='col-5'>
                  <div>
                    <div className='logo-likemais-negativo' />
                  </div>
                  <h3 className='color-brand-1-like my-2'>Mais do que você esperava!</h3>
                  <p className='color-ui-white fontSize20 lineHeight28 mb-2'>O cartão pré-pago que oferece um mundo de possibilidades para suas compras e é válido em qualquer estabelecimento da rede Mastercard® no país.</p>
                  {!hasCard && <a className='color-brand-2-like btn btn-sm txt-uppercase txt-center mb-2'
                    onClick={() => handleClick(this, '.card-tab-like-plus')}>
                    Peça já o seu cartão like mais
                  </a>}
                  {hasCard && <a className='btn btn-outline btn-sm txt-uppercase txt-center' role='button'
                    onClick={() => handleClick(this, '.recharge-tab-like-plus')}>
                    Já tem? Faça uma recarga
                  </a>}
                </div>
              </MediaQuery>
            </div>
            <MediaQuery minDeviceWidth={768}>
              <Anchor href='#card_info_container' data-target='#card_info_container' title='Conheça o cartão like plus' tabIndex={0}>
                <div className='anchor-destaque icon icon_down pos-absolute color-ui-white d-flex flex-column-reverse align-items-center justify-content-center'>
                  <p className='color-ui-white'>Conheça o cartão</p>
                </div>
              </Anchor>
            </MediaQuery>
          </div>
        </div>
        <div className='col-12 p-0 px-md-1 d-flex justify-content-center align-items-center' id='card_info_container'>
          <div className='mt-3 mt-0 d-flex bg-brand-3-like col-12 col-md-11 py-5 subcontainer-destaque flex-column flex-md-row'>
            <MediaQuery maxDeviceWidth={768}>
              <p className='col-12 color-ui-white mb-2 mt-5'>O cartão pré-pago que oferece um mundo de possibilidades para suas compras e é válido em qualquer estabelecimento da rede Mastercard® no país.</p>
            </MediaQuery>
            <h4 className='color-ui-white d-flex justify-content-center align-items-center txt-center px-2'>Como funciona o Cartão Pré-Pago Like+</h4>
            <div className='d-flex col-md-3 col-12 my-2'>
              <div className='color-transparent-like'>1</div>
              <div className='ml-1'>
                <h4 className='color-brand-2-like'>Use seus pontos</h4>
                <p className='color-ui-white'>Tenha pontos disponíveis na sua conta</p>
              </div>
            </div>
            <div className='d-flex col-md-3 col-12 my-2'>
              <div className='color-transparent-like'>2</div>
              <div className='ml-1'>
                <h4 className='color-brand-2-like'>Peça o cartão</h4>
                <p className='color-ui-white'>
                  <span>Sem análise de crédito ou comprovação de renda </span>
                </p>
              </div>
            </div>
            <div className='d-flex col-md-3 col-12 my-2'>
              <div className='color-transparent-like'>3</div>
              <div className='ml-1'>
                <h4 className='color-brand-2-like'>Aproveite!</h4>
                <p className='color-ui-white'>Você gasta só o que for usar e adiciona mais créditos quando precisar</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Banner.propTypes = {
  hasCard: PropTypes.bool
}

function handleClick (e, className) {
  document.querySelector(className).click()
}



// WEBPACK FOOTER //
// ./src/features/LikePlusCustom/Banner.js